module.exports = __webpack_public_path__ + "img/r-cb6-001-2.72f80068.gif";